import React, { useEffect, useRef, useState } from "react";
import { Volume2, VolumeX } from "lucide-react";

const TRACK_URL =
  "https://customer-assets.emergentagent.com/job_acquisition-legal/artifacts/uqm5jh95_Gilded%20Oath.wav";
const LS_KEY = "cm_audio_enabled";
const TARGET_VOLUME = 0.18; // subtle

export default function BackgroundAudio() {
  const audioRef = useRef(null);
  const [enabled, setEnabled] = useState(false);

  // Initial preference
  useEffect(() => {
    try {
      const saved = localStorage.getItem(LS_KEY);
      if (saved === "on") setEnabled(true);
    } catch (_) {}
  }, []);

  // Keep audio element in sync with enabled state
  useEffect(() => {
    const a = audioRef.current;
    if (!a) return;
    a.loop = true;
    a.volume = TARGET_VOLUME;
    if (enabled) {
      a.muted = false;
      a.play().catch(() => {
        // If blocked, fall back to muted autoplay
        a.muted = true;
        a.play().catch(() => {});
      });
    } else {
      a.pause();
    }
    try {
      localStorage.setItem(LS_KEY, enabled ? "on" : "off");
    } catch (_) {}
  }, [enabled]);

  // Attempt muted autoplay on mount (so track is "ready" and any user gesture can unmute)
  useEffect(() => {
    const a = audioRef.current;
    if (!a) return;
    a.loop = true;
    a.volume = TARGET_VOLUME;
    a.muted = true;
    a.play().catch(() => {});
  }, []);

  return (
    <>
      <audio
        ref={audioRef}
        src={TRACK_URL}
        preload="auto"
        loop
        data-testid="background-audio"
      />
      <button
        type="button"
        onClick={() => setEnabled((v) => !v)}
        data-testid="audio-toggle"
        aria-label={enabled ? "Mute background music" : "Play background music"}
        title={enabled ? "Mute background music" : "Play background music"}
        className="fixed z-40 bottom-6 left-6 w-11 h-11 inline-flex items-center justify-center bg-white/90 hover:bg-white border border-cream-300 text-sage-700 hover:text-ochre-500 shadow-sm transition-colors backdrop-blur"
      >
        {enabled ? <Volume2 size={16} /> : <VolumeX size={16} />}
      </button>
    </>
  );
}
